import * as React from 'react'
import { FC } from 'react'
import Box, { BoxProps } from '@mui/material/Box'

const Hands: FC<BoxProps<'svg'>> = (props) => (
  <Box
    component="svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <g clipPath="url(#b)">
        <path
          fill="#FF612B"
          d="M40.48 26.576a2.69 2.69 0 0 0-.69-1.123L24.146 9.807c-4.468-4.467-11.718-4.467-16.184 0-4.48 4.479-4.48 11.729 0 16.196l2.63 2.631a2.53 2.53 0 0 1 .562-.9l2.479-2.48c.97-.97 2.55-.97 3.52 0 .97.971.97 2.55 0 3.52.97-.97 2.549-.97 3.52 0 .97.97.97 2.55 0 3.52.97-.97 2.549-.97 3.52 0 .97.97.97 2.55 0 3.52.97-.97 2.549-.97 3.52 0 .619.62.841 1.497.654 2.304a2.91 2.91 0 0 0 3.333-.526 2.873 2.873 0 0 0 0-4.047 2.873 2.873 0 0 0 4.046 0 2.873 2.873 0 0 0 0-4.046 2.873 2.873 0 0 0 4.046 0 2.81 2.81 0 0 0 .83-2.022 2.96 2.96 0 0 0-.14-.901Zm-18.3.818-.035-.035.093-.023-.058.058Z"
        />
        <path
          fill="#002677"
          d="M41.043 9.809c-4.44-4.44-11.629-4.462-16.102-.074l-.004-.004-9.585 9.585c2.032 2.032 5.358 2.032 7.391 0l5.455-5.455 11.594 11.594c.328.327.561.702.69 1.122l.561-.573c4.479-4.466 4.479-11.717 0-16.195ZM28.368 38.118a2.488 2.488 0 0 1-.655 1.217l-2.479 2.478c-.97.971-2.56.971-3.52 0-.97-.958-.97-2.549 0-3.52-.97.971-2.56.971-3.52 0-.97-.958-.97-2.548 0-3.52-.97.971-2.56.971-3.52 0-.97-.958-.97-2.548 0-3.519-.97.97-2.56.97-3.52 0a2.444 2.444 0 0 1-.56-2.62c.117-.327.304-.63.56-.9l2.48-2.479c.97-.97 2.55-.97 3.52 0 .97.97.97 2.55 0 3.52.97-.97 2.549-.97 3.52 0 .97.97.97 2.55 0 3.52.97-.97 2.549-.97 3.52 0 .97.97.97 2.55 0 3.52.97-.97 2.549-.97 3.52 0 .619.62.841 1.497.654 2.303Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.5 0h48v48H.5z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M.5 0h48v48H.5z" />
      </clipPath>
    </defs>
  </Box>
)
export default Hands
